<div class="contact-item">
  <p class="contact-item__description">
    <!-- contact item description -->
    <span>
      {{ contactData().description | translate }}
    </span>

    <!-- contact item details -->
    @if (contactData().details) {
      <span
        class="description-details {{ contactData().detailsClasses || '' }}">
        {{ contactData().details || '' | translate }}
      </span>
    }
  </p>

  <!-- contact item button -->
  @if (contactData().needAction) {
    <pwj-button
      class="contact-item__button"
      variant="primary"
      size="medium"
      [icon]="contactData().buttonIcon"
      [iconReversePosition]="true"
      [wFull]="true"
      (click)="actionHandler(contactData().action)"
      >{{ contactData().buttonText | translate }}</pwj-button
    >
  } @else {
    <a
      [href]="contactData()?.link"
      [ngClass]="{
        'pointer-events-none':
          !contactData()?.link || contactData()?.link?.includes('undefined'),
      }">
      <pwj-button
        class="contact-item__button"
        variant="primary"
        size="medium"
        [icon]="contactData().buttonIcon"
        [iconReversePosition]="true"
        [wFull]="true"
        [disabled]="
          !contactData()?.link || contactData()?.link?.includes('undefined')
        "
        >{{ contactData().buttonText | translate }}</pwj-button
      >
    </a>
  }
</div>
